/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { ContainerState } from '../../models/container-state';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface GetContainer$Params {
  containerId: string;
}

export function getContainer(
  http: HttpClient,
  rootUrl: string,
  params: GetContainer$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<ContainerState>> {
  const rb = new RequestBuilder(rootUrl, getContainer.PATH, 'get');
  if (params) {
    rb.path('containerId', params.containerId, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContainerState>;
    }),
  );
}

getContainer.PATH = '/manage/messaging/{containerId}';
